const FolderIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 15.339">
            <g id="Group_7705" data-name="Group 7705">
                <path
                    id="Path_3314"
                    data-name="Path 3314"
                    d="M18.625,15.172H1.708A1.228,1.228,0,0,1,.5,13.923V3.622A1.229,1.229,0,0,1,1.709,2.373H13.792a.922.922,0,0,0,.906-.937A.922.922,0,0,1,15.6.5h2.115a.922.922,0,0,1,.907.937v.312a.615.615,0,0,0,.6.625.614.614,0,0,1,.6.624V13.923a1.228,1.228,0,0,1-1.208,1.249"
                    transform="translate(-0.167 -0.167)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3315"
                    data-name="Path 3315"
                    d="M18.625,15.172H1.708A1.228,1.228,0,0,1,.5,13.923V3.622A1.229,1.229,0,0,1,1.709,2.373H13.792a.922.922,0,0,0,.906-.937A.922.922,0,0,1,15.6.5h2.115a.922.922,0,0,1,.907.937v.312a.615.615,0,0,0,.6.625.614.614,0,0,1,.6.624V13.923A1.228,1.228,0,0,1,18.625,15.172Z"
                    transform="translate(-0.167 -0.167)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default FolderIcon;
